import Button from '@jetbrains/ring-ui/components/button/button'
import React from 'react'

import httpsConfigurationApi from '../../../HttpsConfigurationPage.api'
import type {PendingAcmeOrder} from '../../../HttpsConfigurationPage.types'

import styles from './PendingAcmeOrderForm.css'

import IconButton from 'src/components/common/IconButton/IconButton'
import {downloadFile} from 'src/utils/download'

const download = (challengeFileName: string, challengeFileContent: string) => {
  downloadFile(challengeFileContent, challengeFileName, 'application/octet-stream')
}

type Props = {
  pendingAcmeOrder: PendingAcmeOrder
}
function PendingAcmeOrderForm({pendingAcmeOrder}: Props) {
  const hasArtifactsDomain = pendingAcmeOrder.authorizations.length > 1

  const [triggerChallenge, {isLoading: triggerChallengeLoading}] =
    httpsConfigurationApi.endpoints.triggerAcmeChallenge.useMutation()
  const [cancelChallenge, {isLoading: cancelChallengeLoading}] =
    httpsConfigurationApi.endpoints.cancelAcmeChallenge.useMutation()

  return (
    <>
      <div className={styles.verificationMessage}>
        {'Let’s Encrypt requires that you verify your domain ownership before it can ' +
          'issue a certificate.'}
        <br />
        {hasArtifactsDomain
          ? 'Place verification files to the required paths to verify ownership.'
          : 'Place a verification file to the required path to verify ownership.'}
      </div>
      {pendingAcmeOrder.authorizations.map(authorization => (
        <div className={styles.authorization} key={authorization.domain}>
          <div>
            {`Verify domain ownership for the ${authorization.domainDescription} domain `}
            <strong>{authorization.domain}</strong>
          </div>
          <div>
            <b>{'Save the content below to a text file:'}</b>
            <br />
            {authorization.challengeFileContent}
            <IconButton
              icon={'download'}
              title={'Download file'}
              onClick={() =>
                download(authorization.challengeFileName, authorization.challengeFileContent)
              }
            />
          </div>
          <div>
            <b>{'Place the file under the following path:'}</b>
            <br />
            {`http://${authorization.domain}:80/.well-known/acme-challenge/${authorization.challengeFileName}`}
          </div>
        </div>
      ))}
      <div className={styles.controls}>
        <Button
          onClick={triggerChallenge}
          loader={triggerChallengeLoading}
          disabled={cancelChallengeLoading}
          primary
        >
          {'Proceed'}
        </Button>
        <Button
          loader={cancelChallengeLoading}
          disabled={triggerChallengeLoading}
          onClick={cancelChallenge}
        >
          {'Cancel'}
        </Button>
      </div>
    </>
  )
}

export default PendingAcmeOrderForm
